import { IFormSchemaSection } from "../types";

/**
 * The field keys whose value changes should re-fetch the schema. A field is a
 * "trigger" when editing it affects other fields — i.e. its `operations.triggers`
 * (the inverse dependency list the forms engine emits) is non-empty. We watch
 * those keys; on change the engine re-evaluates visibility / computed / validation
 * server-side. (We do NOT watch the dependent fields themselves.)
 */
export const selectorTriggerFields = (
  sections: IFormSchemaSection[]
): string[] => {
  const triggerKeys = new Set<string>();
  sections.forEach(section => {
    section.fields.forEach(field => {
      if (field.operations.triggers.length > 0) {
        triggerKeys.add(field.key);
      }
    });
  });
  return Array.from(triggerKeys);
};
